'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$getPrototypeOf = _interopDefault(require('babel-runtime/core-js/object/get-prototype-of'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var _possibleConstructorReturn = _interopDefault(require('babel-runtime/helpers/possibleConstructorReturn'));
var _get = _interopDefault(require('babel-runtime/helpers/get'));
var _inherits = _interopDefault(require('babel-runtime/helpers/inherits'));
var $ = _interopDefault(require('jquery'));
var Twine = _interopDefault(require('twine'));
var Breakpoints = _interopDefault(require('../../global/breakpoints.js'));
var StatefulForm = _interopDefault(require('../stateful-form.js'));
var FormsAPI = _interopDefault(require('../forms-api.js'));
var signupTracker = _interopDefault(require('./signup-tracker.js'));
require('./signup-hidden-fields.js');

var SignupForm = function (_StatefulForm) {
  _inherits(SignupForm, _StatefulForm);

  function SignupForm(form, i18nNamespace, successEvent) {
    _classCallCheck(this, SignupForm);

    var _this = _possibleConstructorReturn(this, (SignupForm.__proto__ || _Object$getPrototypeOf(SignupForm)).call(this, form, i18nNamespace));

    _this.successEvent = successEvent || signupTracker.config.gaEvents.success;
    _this.breakpoints = new Breakpoints();

    function shopNameValidation(value) {
      var email = this.fields.email.state.value;
      var pw = this.fields.password.state.value;
      var hasSubdomainField = Boolean(this.fields.subdomain);
      return FormsAPI.validateShopName(email, pw, value, { checkAvailability: !hasSubdomainField });
    }

    function shopSubdomainValidation(value) {
      return FormsAPI.subdomainAvailable(value);
    }

    _this.validationFns.shop_name = shopNameValidation.bind(_this); // eslint-disable-line camelcase
    _this.validationFns.subdomain = shopSubdomainValidation.bind(_this);
    _this.pending = false;
    return _this;
  }

  _createClass(SignupForm, [{
    key: 'getHiddenFields',
    value: function getHiddenFields() {
      return ShopifyMarketing.context[this.$form.data('hiddenFieldsNamespace')];
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      var _this2 = this;

      this.pending = true;
      Twine.refresh();
      var hiddenFields = this.getHiddenFields();

      if (hiddenFields) {
        // This will set hidden input value via Twine refresh that gets triggered
        // on submit.
        hiddenFields.setField('y', hiddenFields.y());
      }

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _get(SignupForm.prototype.__proto__ || _Object$getPrototypeOf(SignupForm.prototype), 'handleSubmit', this).call(this, args).always(function () {
        _this2.pending = false;
      });
    }
  }, {
    key: 'preSubmitHook',
    value: function preSubmitHook() {
      $(document.body).trigger('signupSuccess', { signupForm: this });

      return signupTracker.trackSuccess(this.successEvent, this.isCustomEmail());
    }
  }, {
    key: 'populateEmail',
    value: function populateEmail(value) {
      var _this3 = this;

      var emailField = this.fields.email;

      emailField.setState({ value: value });
      emailField.handleBlur();

      return this.validateFieldIfSet(emailField).always(function () {
        if (!emailField.state.value || emailField.state.error) {
          _this3.focusOnField('email');
        } else if (_this3.breakpoints.matches('tabletUp')) {
          _this3.focusOnField('password');
        }
      });
    }
  }, {
    key: 'isCustomEmail',
    value: function isCustomEmail() {
      var email = this.fields.email.state.value;

      return FormsAPI.isCustomEmail(email);
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'fieldErrorHook',
    value: function fieldErrorHook(field) {
      if (!field.state.error) {
        return;
      }

      signupTracker.sendGAEvent('error_' + field.name);
      signupTracker.trackError(field.name, field.state.errors, field.state.value);
    }
  }, {
    key: 'handleEmailSuggestionClick',
    value: function handleEmailSuggestionClick() {
      var emailField = this.fields.email;

      signupTracker.sendGAEvent('mailcheck');
      emailField.setState({
        value: emailField.state.suggestion.full,
        hint: false
      });
    }
  }]);

  return SignupForm;
}(StatefulForm);

Twine.register('SignupForm', SignupForm);

module.exports = SignupForm;
